// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListSection_wrapper__2Kwzw"};